import { create } from 'zustand';
import { getLocale } from '@/utils/getLocale';
import Cookies from "universal-cookie";
import i18n from '@/utils/i18n';

const cookies = new Cookies();

interface LangTimeState {
    lang: "pt" | "en";
    setLang: (lang: "pt" | "en") => void;
}

const useLangTimeStore = create<LangTimeState>((set) => ({
    lang: getLocale(),
    setLang: (lang: "pt" | "en") => {
        cookies.set("pref_lang", lang, { path: "/", sameSite: "none", secure: true });
        set({ lang: lang });
        i18n.changeLanguage(lang).catch((error) => {
            console.error("Failed to change language:", error);
        });
    }
}));

export { useLangTimeStore };